import { Component, HostListener, ChangeDetectorRef, inject, DestroyRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  BarController,
  BarElement,
  Chart
} from 'chart.js';
import { LinearScale, CategoryScale } from 'chart.js';
import { CustomerSummaryDTO } from 'src/app/models/CustomerSummaryDTO.model';
import { CustomerService } from 'src/app/services/customer.service';
import { SimpleRequestDTO } from 'src/app/shared/models/SimpleRequest';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { AddDeviceService } from 'src/app/services/add-device.service';
import { TDeviceUsageDTO } from 'src/app/models/TDeviceUsageDTO.model';
import { Alert } from 'src/app/shared/models/Alert';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ResponseDataFile } from 'src/app/shared/models/ApiResponse';
import { UserRequestDTO } from 'src/app/shared/models/UserRequestDto';
import { saveAs } from 'file-saver';
import { CustomerPlanSummaryDTO } from 'src/app/models/CustomerPlanSummaryDTO.model';
import { PlanDeviceSummaryDTO } from 'src/app/models/PlanDeviceSummaryDTO.model';
import { SimpleRequestLongList } from 'src/app/shared/models/SimpleRequestLongList';
import { UserDTO } from 'src/app/models/UserDTO.model';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import { TableColumn } from 'src/app/models/TableColumn';
import { DeviceDTO } from 'src/app/models/DeviceDTO.model';
import { Subject, takeUntil } from 'rxjs';
import { ResponseBase } from 'src/app/models/ResponseBase';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CustomerFormComponent } from '../customer-form/customer-form.component';
import { TableControlComponent } from '../../../shared/controls/table-control/table-control.component';
import { TooltipDirective } from '../../../directives/tooltip.directive';
declare var bootstrap: any;

@Component({
  selector: 'app-view-customer',
  templateUrl: './view-customer.component.html',
  styleUrls: ['./view-customer.component.css'],
    imports: [
        CommonModule,
        FormsModule,
        CustomerFormComponent,
        TableControlComponent,
        TooltipDirective
    ]
})
export class ViewCustomerComponent {
  customerId?: number = undefined;

  customer: UserDTO = {} as UserDTO;

  request: SimpleRequestDTO = {} as SimpleRequestDTO;
  information: string = '';
  //customerSummary: CustomerSummaryDTO = {} as CustomerSummaryDTO;
  simpleDataRequestLong: SimpleRequestDTO = {} as SimpleRequestDTO;
  chart: Chart | undefined;
  alert: Alert = {} as Alert;
  userRequestDTO: UserRequestDTO = {} as UserRequestDTO;
  pagesToShow: number = 5;
  recordsPerPage: number = 10;
  currentPage: number = 1;
  currentPageDev: number = 1;
  originalDevicesMap: Map<number, PlanDeviceSummaryDTO[]> = new Map();
  currentPagePlan: number = 1;
  totalPagesPlan: number = 1;
  recordsPerPagePlan: number = 10;
  textoBusqueda: string = '';
  mainContact?: string;
  mainContactNumber?: string;

  selectedIccid?: string = '';


  viewArchivedPlans: boolean = false;

  informationFilters: string = 'Please select the start and end dates for the report query.';
  camposBusqueda: string[] = [
    'price',
    'description',
    'allowance',
    'currentConsumption'
  ];

  totalPages: number = 0;

  simpleDataRequestLongList: SimpleRequestLongList = {} as SimpleRequestLongList;

  textoBusquedaDev: string = '';
  camposBusquedaDev: string[] = [
    'primary',
    'usageOnPeriod',
    'iccid',
    'mtn',
    'imei',
    'ip',
    'username',
    'ratePlan',
    'custom1',
    'activationDate',
    'carrier'
  ];

  totalPagesDev: number = 0;
  monthlyConsumption: number[] = [];
  monthlyHistoryConsumption: number[] = [];
  rangeMonts: string[] = [];

  selectedValue: number = 50; // Valor inicial del control de rango (entre 50 y 100)
  userDto: UserDTO = {} as UserDTO;
  fromDate?: string = undefined;
  toDate?: string = undefined;
  fieldsCompletedFilter?: boolean = false;
  planselectedModal: CustomerPlanSummaryDTO = {} as CustomerPlanSummaryDTO;

  devicesColumns: TableColumn[] = [
    { key: 'primary', header: 'Primary', },
    { key: 'usageOnPeriod', header: 'Usage in MB', format: { type: 'number', decimalPlaces: 2 }, },
    { key: 'iccid', header: 'ICCID', },
    { key: 'mtn', header: 'MTN', },
    { key: 'imei', header: 'IMEI', },
    { key: 'ip', header: 'IP Adress', },
    { key: 'username', header: 'User Name', width: 200, },
    { key: 'username2', header: 'User Name 2', width: 200, },
    { key: 'custom1', header: 'Custom Field 1', width: 200, },
    { key: 'activationDate', header: 'Activation Date', format: { type: 'date', dateFormat: 'MM-dd-yyyy' }, },
    { key: 'carrier', header: 'Carrier', },
    { key: 'nameStatus', header: 'Status', },
  ];

  actionButtons = [
    { label: 'Activate', class: 'primary', icon: 'bi bi-check2-circle', showLabel: true },

  ];

  onAction(event: { action: string; item: DeviceDTO }): void {

    // Handle different actions
    switch (event.action) {
      case 'Activate':
        this.selectedIccid = event.item.iccid;

        this.router.navigate(['/customers/device-activation', this.selectedIccid], {
          relativeTo: this.route,
          state: {
            listPlans: this.listOfPlans,

          },
        });
        break;

    }
  }

  plansColumns: TableColumn[] = [

    { key: 'planName', header: 'Plan', },
    { key: 'description', header: 'Description', },
    {
      key: 'price',
      header: 'Price',
      format: {
        type: 'currency',
        customFormatter: (value: any) => {
          return value ? `$ ${Number(value).toLocaleString(
            undefined, { minimumFractionDigits: 2 }
          )}` : '';
        }
      }

    },
    {
      key: 'allowance', header: 'Allowance MB',
      format: {
        type: 'number',
        decimalPlaces: 2,
        customFormatter: (value: any) => {
          return value ? `${Number(value).toLocaleString(
            undefined, { minimumFractionDigits: 2 }
          )} MB` : 'N/A';
        }
      }
    },
    {
      key: 'currentConsumption',
      header: 'Current Usage MB',
      format: {
        type: 'number',
        decimalPlaces: 2,
        customFormatter: (value: any) => {
          return value ? `${Number(value).toLocaleString(
            undefined, { minimumFractionDigits: 2 }
          )} MB` : 'N/A';
        }
      },

    },
    {
      key: 'status',
      header: 'Status',
      format: {
        type: 'number',
        decimalPlaces: 0,
        customFormatter: (value: any) => {
          return value === 1 ? 'Active' : 'Archived';
        }
      },
    },
  ];

  OriginalListOfPlans: CustomerPlanSummaryDTO[] = []
  listOfPlans: CustomerPlanSummaryDTO[] = []

  plansActionButtons = [
    { label: 'View', class: 'info', icon: 'bi bi-bar-chart' },

  ];

  onPlansAction(event: { action: string; item: CustomerPlanSummaryDTO }): void {

    // Handle different actions
    switch (event.action) {
      case 'View':
        event.item.userPlanId;

        this.router.navigate([`/customers/view-customer/${this.customerId}/${event.item.userPlanId}`], {
          relativeTo: this.route,
          // state: {
          //   listPlans: this.customerSummary.listPlans,

          // },
        })
        break;

    }
  }



  unassingnedDevicesColumns: TableColumn[] = [

    { key: 'iccid', header: 'ICCID', },

    { key: 'nameStatus', header: 'Status', },
  ];
  unassingnedDevices: DeviceDTO[] = []

  constructor(
    private route: ActivatedRoute,
    private customerService: CustomerService,
    private router: Router,
    private addDeviceService: AddDeviceService,
    private alertService: AlertService,
    private cdr: ChangeDetectorRef,
    public permissionsService: ValidatePermissionsService,

  ) { }

  ngOnInit() {
    
    this.permissionsService.validateAccessLevels(MODULE_ID.Customers);

    this.route.params.subscribe((params) => {

      this.customerId = params['id'];

      this.information = 'Customer ID/Account: ' + params['id'];
      this.request.id = params['id'];

    });

    this.customerService.getCustomerPlans(this.customerId).subscribe(
      {
        next: (data) => {
          this.OriginalListOfPlans = [...data];
          this.listOfPlans = data.filter(plan => plan.status == 1);
        },
        error: (error) => {

        },
        complete: () => {

        }
      }
      // (data: CustomerPlanSummaryDTO[]) => {
      //   this.OriginalListOfPlans = data;
      //   this.listOfPlans = data.filter(plan => plan.status == 1);
      //   this.cdr.detectChanges(); // Use sparingly
      // },
      // // data != null
      // //   ? this.handleSaveSuccess(data)
      // //   : this.handleSaveError(data.StatusCode),
      // (error) => {
      //   this.clearFields();
      // }
    );

    this.customerService.getDevicesNotYetAssignedToAPlan(this.customerId).subscribe(
      (response: DeviceDTO[]) => {

        this.unassingnedDevices = response;
      },
      (error: any) => {
        //this.clearFields();
      }
    );
  }

  onCheckboxChange(event: any) {
    this.viewArchivedPlans = event.target.checked;
    if (this.viewArchivedPlans) {
      this.listOfPlans = this.OriginalListOfPlans.filter(plan => plan.status == 2);
    } else {
      this.listOfPlans = this.OriginalListOfPlans.filter(plan => plan.status == 1);
    }
  }


  clearFields() { }

  goBack() {
    this.router.navigate(['/customers']);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.chart?.resize(); // Llama al método resize de tu instancia de gráfico
  }



  onUserLoaded(user: UserDTO) {
    this.customer = user;
  }

  // HandleGetListCustomersError(StatusCode: number) {
  //   this.alert = {
  //     alertMessage: 'Unexpected error. Please try again later.',
  //     alertType: 'alert alert-danger',
  //     alertCenter: false,
  //     alerTitle: '',
  //     duration: 3000
  //   };
  //   this.alertService.updateAlertState(
  //     this.alert
  //   );
  // }

  exportToExcelListPlan() {
    
    this.userRequestDTO.userId = Number(this.customerId);
    this.customerService.exportToExcelListCustomerPlans(this.userRequestDTO).subscribe(
      (response: ResponseDataFile) => {
        if (response) {
          this.handleDownload(response);
        } else {
          this.handleGetListError();
        }
      },
      (error) => {
        console.error('Error al exportar el archivo Excel:', error);
      }
    );
  }

  private handleDownload(data: ResponseDataFile) {
    const byteCharacters = atob(data.Data.fileContents);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: data.Data.contentType });
    saveAs(blob, data.Data.fileDownloadName || 'export.xlsx');

    this.alert = {
      alertMessage: 'File generated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
  }

  private handleGetListError() {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }

  exportToExcelListPlanDevices(plan: CustomerPlanSummaryDTO) {

    
    let planDeviceIdList: number[] = [];
    let originalDevices = this.originalDevicesMap.get(plan.userPlanId) || [];

    if (plan.listDevices.length === originalDevices.length) {
      planDeviceIdList = [];
    } else {
      planDeviceIdList = plan.listDevices
        .filter((device: PlanDeviceSummaryDTO) => device.aPlanDeviceId !== undefined)
        .map((device: PlanDeviceSummaryDTO) => device.aPlanDeviceId as number);
    }

    this.simpleDataRequestLongList.id = plan.userPlanId;
    this.simpleDataRequestLongList.listIds = planDeviceIdList;

    this.addDeviceService.exportToExcelListPlanDevices(this.simpleDataRequestLongList).subscribe(
      (response: ResponseDataFile) => {
        if (response) {
          this.handleDownloadDevice(response);
        } else {
          this.handleGetFileErrorDevice();
        }
      },
      (error) => {
        console.error('Error al exportar el archivo Excel:', error);
      }
    );
  }

  exportToExcelListPlanDevicesAnnual(confirmation: boolean) {
    
    if (confirmation) {
      let planDeviceIdList: number[] = [];
      let originalDevices = this.originalDevicesMap.get(this.planselectedModal.userPlanId) || [];

      if (this.planselectedModal.listDevices.length === originalDevices.length) {
        planDeviceIdList = [];
      } else {
        planDeviceIdList = this.planselectedModal.listDevices
          .filter((device: PlanDeviceSummaryDTO) => device.aPlanDeviceId !== undefined)
          .map((device: PlanDeviceSummaryDTO) => device.aPlanDeviceId as number);
      }

      this.simpleDataRequestLongList.id = this.planselectedModal.userPlanId;
      this.simpleDataRequestLongList.listIds = planDeviceIdList;
      this.simpleDataRequestLongList.fromDate = this.fromDate !== undefined ? new Date(this.fromDate) : undefined;
      this.simpleDataRequestLongList.toDate = this.toDate !== undefined ? new Date(this.toDate) : undefined;


      this.addDeviceService.exportToExcelListPlanDevicesAnnual(this.simpleDataRequestLongList).subscribe(
        (response: ResponseDataFile) => {
          if (response) {
            this.handleDownloadDevice(response);
          } else {
            this.handleGetFileErrorDevice();
          }
        },
        (error) => {
          console.error('Error al exportar el archivo Excel:', error);
        }
      );
    }
  }

  exportToExcelListPlanDevicesConsolidated(plan: CustomerPlanSummaryDTO) {
    
    let planDeviceIdList: number[] = [];
    let originalDevices = this.originalDevicesMap.get(plan.userPlanId) || [];

    if (plan.listDevices.length === originalDevices.length) {
      planDeviceIdList = [];
    } else {
      planDeviceIdList = plan.listDevices
        .filter((device: PlanDeviceSummaryDTO) => device.aPlanDeviceId !== undefined)
        .map((device: PlanDeviceSummaryDTO) => device.aPlanDeviceId as number);
    }

    this.simpleDataRequestLongList.id = plan.userPlanId;
    this.simpleDataRequestLongList.listIds = planDeviceIdList;

    this.addDeviceService.exportToExcelListPlanDevicesConsolidated(this.simpleDataRequestLongList).subscribe(
      (response: ResponseDataFile) => {
        if (response) {
          this.handleDownloadDevice(response);
        } else {
          this.handleGetFileErrorDevice();
        }
      },
      (error) => {
        console.error('Error al exportar el archivo Excel:', error);
      }
    );
  }

  private handleDownloadDevice(data: ResponseDataFile) {
    const byteCharacters = atob(data.Data.fileContents);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: data.Data.contentType });
    saveAs(blob, data.Data.fileDownloadName || 'export.xlsx');

    this.alert = {
      alertMessage: 'File generated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
  }

  private handleGetFileErrorDevice() {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }



  safeToString(value: any): string {
    return value !== null && value !== undefined ? value.toString().toLowerCase() : '';
  }



  HandleGetCustomer(customer: UserDTO) {
    this.selectedValue = customer.alertSendPercentage ?? 50;
    this.userDto = customer;
  }

  HandleGetCustomerError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }


  // Método para abrir el modal
  openModal(): void {
    const modalElement = document.getElementById('configurationsModal');
    if (modalElement) {
      const modalInstance = new bootstrap.Modal(modalElement);
      modalInstance.show();
    }
  }

  // Método para cerrar el modal y limpiar backdrop
  closeModal(): void {
    const modalElement = document.getElementById('configurationsModal');
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide(); // Cerrar el modal
      }
    }

    // Asegurarse de que el fondo oscuro (backdrop) se elimina
    const modalBackdrop = document.querySelector('.modal-backdrop');
    if (modalBackdrop) {
      modalBackdrop.remove(); // Remover el fondo oscuro manualmente
    }

    // También asegurarnos de que se elimine la clase `modal-open` del body
    document.body.classList.remove('modal-open');
  }

  // Método para actualizar el valor del rango
  updateValue(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.selectedValue = Number(inputElement.value); // Actualiza el valor seleccionado
  }

  updatePlansPercentage() {
    
    this.customerService
      .updateUserPercentageAlert(this.listOfPlans)
      .subscribe(
        ({ StatusCode, Message, Data }) => {
          if (Data != null) {
            this.HandleUpdate(Data);
          } else {
            this.HandleUpdateError(StatusCode);
          }
        },
        (error) => {
          this.alert = {
            alertMessage: 'Unexpected error. Please try again later.',
            alertType: 'alert alert-danger',
            alertCenter: false,
            alerTitle: '',
            duration: 3000
          };
          this.alertService.updateAlertState(
            this.alert
          );
        }
      );

    this.closeModal();
  }

  async HandleUpdate(customer: boolean) {
    this.alert = {
      alertMessage: 'Settings updated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
  }

  HandleUpdateError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }

  openConfirmationData(plan: CustomerPlanSummaryDTO) {

    this.planselectedModal = plan;
    const secondModalElement = document.getElementById('confirmationData');
    if (secondModalElement) {
      const secondModal = new bootstrap.Modal(secondModalElement);
      secondModal.show();
    }
  }

  checkFieldsFilter() {
    if (this.fromDate && this.toDate) {
      if (new Date(this.fromDate) >= new Date(this.toDate)) {
        this.toDate = "";
        this.fieldsCompletedFilter = false;
      }
      else {
        this.fieldsCompletedFilter = true;
      }
    }
    else {
      this.fieldsCompletedFilter = false;
    }
  }

  minDate(): string | null {
    if (this.fromDate) {
      const minDate = new Date(this.fromDate);
      minDate.setDate(minDate.getDate() + 1);
      return minDate.toISOString().split('T')[0];
    }
    return null;
  }

  navigateToCustomerUsers() {
    this.router.navigate(['/customers/customer-users/', this.request.id], {
      relativeTo: this.route,


    });
  }

  
}
